module.exports = __webpack_public_path__ + "img/10.836be2d8.webp";